import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Remove the "Made with Emergent" badge (static + any re-injected)
const stripBadge = () =>
  document
    .querySelectorAll('#emergent-badge, a[href*="utm_source=emergent-badge"]')
    .forEach((n) => n.remove());
stripBadge();
if (document.body) {
  new MutationObserver(stripBadge).observe(document.body, { childList: true, subtree: true });
}
